import {LOCALIZATION} from "../../actions";

export default (state = [], action) => {
    switch (action.type) {
        case LOCALIZATION:
            return action.payload;
        default:
            return state;
    }
};